import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

class GoogleAdsenseForResponsiveForm extends Component {

    validate(setting) {
        return ((setting.adsenseResponsiveType === 'above' && setting.adsenseResponsiveAd1)
            || (setting.adsenseResponsiveType === 'below' && setting.adsenseResponsiveAd2)
            || (setting.adsenseResponsiveType === 'both' && setting.adsenseResponsiveAd1 && setting.adsenseResponsiveAd2))
    }

    componentDidMount() {
        const { onChange } = this.props
        onChange(
            Object.assign({},  this.props.data,{
                validated: this.validate(this.props.data.setting)
            })
        )
    }

    @autobind
    handleADTypeChange(ADType) {
        const { onChange } = this.props
        let setting = Object.assign({},  this.props.data.setting, {
            adsenseResponsiveType: ADType
        })
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleADCodeChange(type, ADCode) {
        const { onChange } = this.props
        var newObject = Object();
        newObject[type] = ADCode;
        let setting = Object.assign({},  this.props.data.setting, newObject)
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin9">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            광고 배치 유형 중에 1 가지를 선택해주세요.
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            광고 코드 입력창에 애드센스 광고 코드를 넣어주세요.
                            <a href="https://support.google.com/adsense/answer/3543893" target="_blank" className="link_other">애드센스 바로가기</a>
                        </li>
                        <li>
                            <span className="txt_em">3</span>
                            적용 버튼을 누르면 설정이 완료됩니다.
                        </li>
                    </ol>
                </div>
                <fieldset>
                    <legend className="tit_set">광고 형태</legend>
                    <div className="list_google">
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adsenseResponsiveType == "above"} onChange={(e)=>this.handleADTypeChange('above')}/>
                            <span className="ico_google ico_google3">상단 전체</span>
                        </label>
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adsenseResponsiveType == "below"} onChange={(e)=>this.handleADTypeChange('below')}/>
                            <span className="ico_google ico_google5">하단 전체</span>
                        </label>
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adsenseResponsiveType == "both"} onChange={(e)=>this.handleADTypeChange('both')}/>
                            <span className="ico_google ico_google8">상단, 하단 전체</span>
                        </label>
                    </div>
                    {(data.setting.adsenseResponsiveType == "above"||data.setting.adsenseResponsiveType == "both")&&(
                        <textarea className="tf_blog" title="광고 코드 입력"
                                  placeholder="글 상단에 넣을 반응형 광고 코드를 붙여넣으세요." onChange={(e)=>this.handleADCodeChange('adsenseResponsiveAd1', e.target.value)}>{data.setting.adsenseResponsiveAd1}</textarea>
                    )}
                    {(data.setting.adsenseResponsiveType == "below"||data.setting.adsenseResponsiveType == "both")&&(
                        <textarea className="tf_blog" title="광고 코드 입력"
                                  placeholder="글 하단에 넣을 반응형 광고 코드를 붙여넣으세요." onChange={(e)=>this.handleADCodeChange('adsenseResponsiveAd2', e.target.value)}>{data.setting.adsenseResponsiveAd2}</textarea>
                    )}
                </fieldset>
                {this.props.saveButton()}
            </div>
        )
    }
}

GoogleAdsenseForResponsiveForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default GoogleAdsenseForResponsiveForm
